import { useMutation, useQuery } from "@tanstack/react-query";

import type { SetActiveGroupRequest } from "@/src/models/group";
import { getGroupContext, setActiveGroup } from "@/src/requests/group";

export const GROUP_CONTEXT_QUERY_KEY = ["group-context"];

export function useGroupContext(stytchOrgId?: string) {
  return useQuery({
    queryKey: [...GROUP_CONTEXT_QUERY_KEY, stytchOrgId],
    queryFn: getGroupContext,
    enabled: Boolean(stytchOrgId),
  });
}

export function useSetActiveGroup() {
  return useMutation({
    mutationFn: (request: SetActiveGroupRequest) => setActiveGroup(request),
  });
}
